import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Layout Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Public Pages
import Home from "./pages/Home";
import Sobre from "./pages/Sobre";
import Jornada from "./pages/Jornada";
import Equipe from "./pages/Equipe";
import Conquistas from "./pages/Conquistas";
import Galeria from "./pages/Galeria";
import Eventos from "./pages/Eventos";
import Apoie from "./pages/Apoie";
import Contato from "./pages/Contato";

// Admin Pages
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminAtletas from "./pages/admin/AdminAtletas";
import AdminEventos from "./pages/admin/AdminEventos";
import AdminConquistas from "./pages/admin/AdminConquistas";
import AdminNoticias from "./pages/admin/AdminNoticias";
import AdminGaleria from "./pages/admin/AdminGaleria";
import AdminContatos from "./pages/admin/AdminContatos";
import AdminConfig from "./pages/admin/AdminConfig";

// Public Layout wrapper
const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/sobre" element={<PublicLayout><Sobre /></PublicLayout>} />
          <Route path="/jornada" element={<PublicLayout><Jornada /></PublicLayout>} />
          <Route path="/equipe" element={<PublicLayout><Equipe /></PublicLayout>} />
          <Route path="/conquistas" element={<PublicLayout><Conquistas /></PublicLayout>} />
          <Route path="/galeria" element={<PublicLayout><Galeria /></PublicLayout>} />
          <Route path="/eventos" element={<PublicLayout><Eventos /></PublicLayout>} />
          <Route path="/apoie" element={<PublicLayout><Apoie /></PublicLayout>} />
          <Route path="/contato" element={<PublicLayout><Contato /></PublicLayout>} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="atletas" element={<AdminAtletas />} />
            <Route path="eventos" element={<AdminEventos />} />
            <Route path="conquistas" element={<AdminConquistas />} />
            <Route path="noticias" element={<AdminNoticias />} />
            <Route path="galeria" element={<AdminGaleria />} />
            <Route path="contatos" element={<AdminContatos />} />
            <Route path="config" element={<AdminConfig />} />
          </Route>
        </Routes>
      </HashRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
